<!-- Fondo oscuro: cierra el panel al hacer clic -->
<div class="off-overlay" *ngIf="open" (click)="closed.emit()"></div>

<aside class="offsidebar-fixed filter-sidebar" [class.open]="open">
  <div>
    <!-- Pestaña de cierre (en compacto se vuelve la barra superior) -->
    <em
      class="fa fa-times text-white p-2 c-pointer filter-sidebar-close"
      *ngIf="open"
      role="button"
      [attr.aria-label]="'general.close' | translate"
      (click)="closed.emit()"
    ></em>

    <div class="filter-sidebar-header">
      <em class="fa fa-filter"></em>
      <h3 class="m-0">{{ "filter.filters" | translate }}</h3>
    </div>

    <!-- Controles proyectados desde la pagina -->
    <div class="off-body filter-sidebar-body">
      <ng-content></ng-content>
    </div>

    <div class="filter-sidebar-footer" *ngIf="hasClear">
      <button type="button" class="btn btn-secondary btn-block" (click)="cleared.emit()">
        {{ "filter.clear" | translate }}
      </button>
    </div>
  </div>
</aside>
